import { render } from "./DialogsList.vue?vue&type=template&id=1a38ffde&scoped=true"
import script from "./DialogsList.vue?vue&type=script&lang=js"
export * from "./DialogsList.vue?vue&type=script&lang=js"

import "./DialogsList.vue?vue&type=style&index=0&id=1a38ffde&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a38ffde"]])

export default __exports__